import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import ReCAPTCHA from "react-google-recaptcha"
import { directAxiosInstance } from "@lib/api"
import { getAssetPath, Validate } from "@commonUtils"
import InputField from "@components/nonDLSComponents/InputField/InputField.js"
import css from "../Auth.scss"
import { setModalName, setDefault, clearUserInfo, setAuthType } from "../reducer"
import Button from "@components/Button/Button"
import { setDefaultAuthConfig } from "@containers/App/reducer"
import { useDispatch, useSelector } from "react-redux"
import ARIAButton from "@wrappers/ARIAButton/ARIAButton"
const NeedHelp = ({ localDispatch }) => {
    const { authConfig } = useSelector((state) => state.shellReducer)
    const dispatch = useDispatch()
    const [email, setEmail] = useState("")
    const [helpQuery, setHelpQuery] = useState("")
    const [captchaKey, setCaptchaKey] = useState(null)
    const [error, setError] = useState(null)
    const [ctaLabel, setCtaLabel] = useState("Submit")
    const [iconUrl, setIconUrl] = useState(null)
    const [focused, setFocused] = useState(false)

    const onFocus = () => {
        setFocused(true)
    }
    const onBlur = () => {
        if (email === "" && helpQuery === "") {
            setFocused(false)
        }
    }
    /**
     * @description when user come on this screen cursor should be on inputField .
     */
    const inputRef = useRef(null)
    useEffect(() => {
        setFocused(true)
    }, [])
    /**
     *
     * @description Function to submit the form by clicking on enter
     */
    const onKeyUp = (event) => {
        if (event.key === "Enter") {
            handleSubmit()
        }
    }
    // we are using "active" as a flag so that untill the request is completed, we do not allow multiple request
    // on multiple clicks on cta
    const [active, setActive] = useState(false)

    /**
     * @description Function to check valid input
     */
    const errorCheck = () => {
        setError(null)

        const errs = Validate({
            email: email,
            textarea: helpQuery,
        })
        setError(errs)
        return errs
    }

    const onCaptchaChange = (captchaKey) => setCaptchaKey(captchaKey)

    /**
     * @description Function to handle query submit
     */
    const handleSubmit = () => {
        const errs = errorCheck()
        errs && setError(errs)
        if (!errs && !active) {
            setActive(true)
            setIconUrl(getAssetPath("svgs/icons/loading-wheel_24px_background.svg"))
            directAxiosInstance()
                .post("auth/login-help", {
                    query: helpQuery,
                    recaptcha_response_field: captchaKey,
                    email,
                })
                .then((res) => {
                    if (res && res?.data) {
                        if (!res?.data?.errors && !res?.data?.error && res.data === "success") {
                            localDispatch(setDefault())
                            dispatch(setDefaultAuthConfig())
                            localDispatch(setModalName("NeedHelp"))
                            setTimeout(() => {
                                localDispatch(setModalName(null))
                            }, 5000)
                        } else {
                            const err = res.data.error.message
                            setError({ textarea: err })
                        }
                    }
                    setIconUrl(null)
                    setCtaLabel("Submit")
                    setActive(false)
                })
                .catch((err) => {
                    setIconUrl(null)
                    setCtaLabel("Submit")
                    const errMsg = (err && err?.data && err?.data?.error) || "Server error"
                    setError({ textarea: errMsg })
                    setActive(false)
                })
        }
    }

    return (
        <>
            <div className={css.rightContainer}>
                {!authConfig.restrictUserFromClosingAuth && (
                    <div className={`flex ${css.crossIcon} ${css.cursorPointer}`}>
                        <div>
                            <ARIAButton
                                onClick={() => {
                                    dispatch(setDefaultAuthConfig())
                                    localDispatch(setDefault())
                                }}
                                ariaLabel={"Close need help popup"}
                            >
                                <img
                                    src={getAssetPath("svgs/icons/cross_18px_primary.svg")}
                                    alt={"Close icon"}
                                />
                            </ARIAButton>
                        </div>
                    </div>
                )}

                <div className={css.authContainer}>
                    <div className={`${css.paddingAuth} flexColumn `}>
                        <div>
                            <span className={css.heading}>Need Help?</span>
                            <div className={`smallRegular textSecondary ${css.needHelpSubHeadingMargin}`}>
                                Our customer care team will get back to you on your email id
                            </div>
                            <div data-testid="email_input">
                                <InputField
                                    name="email"
                                    label="Enter your email id"
                                    type="text"
                                    value={email}
                                    onChange={setEmail}
                                    onBlur={() => onBlur()}
                                    alertType={"error"}
                                    alertMessage={error && error.email}
                                    borderType={"tertiary"}
                                    onFocus={() => onFocus()}
                                    focused={focused}
                                    onKeyUp={(e) => onKeyUp(e)}
                                    ref={inputRef}
                                />
                            </div>
                            <div data-testid="query_input">
                                <InputField
                                    name="helpQuery"
                                    label="Write your query here"
                                    value={helpQuery}
                                    onBlur={() => onBlur()}
                                    type="textarea"
                                    multiLine
                                    onChange={setHelpQuery}
                                    alertType={"error"}
                                    alertMessage={error && error.textarea}
                                    borderType={"tertiary"}
                                    focused={focused}
                                    onFocus={() => onFocus()}
                                    onKeyUp={(e) => onKeyUp(e)}
                                />
                            </div>
                            <div className={` marginTop-16`}>
                                <ReCAPTCHA sitekey={process.env.RECAPTCHA_KEY} onChange={onCaptchaChange} />
                            </div>
                        </div>
                        <div>
                            <div className="flexColumn alignCenter marginTop-48">
                                <Button
                                    label={!iconUrl ? ctaLabel : null}
                                    iconUrl={iconUrl}
                                    isDisabled={iconUrl ? true : false}
                                    onClick={() => handleSubmit()}
                                />
                                <div className="marginTop-16 flex alignCenter justifyCenter">
                                    <span
                                        className={`textAction bodySemiBold ${css.cursorPointer}`}
                                        onClick={() => {
                                            localDispatch(clearUserInfo())
                                            localDispatch(setAuthType("Login"))
                                        }}
                                    >
                                        Login
                                    </span>
                                    <div className={`${css.marginBoth12} textSecondary`}>|</div>
                                    <span
                                        className={`textAction bodySemiBold ${css.cursorPointer}`}
                                        onClick={() => {
                                            localDispatch(clearUserInfo())
                                            localDispatch(setAuthType("SignUp"))
                                        }}
                                    >
                                        Sign Up
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

NeedHelp.propTypes = {
    localDispatch: PropTypes.func.isRequired,
}

export default NeedHelp
